import * as React from 'react';
import { useEffect, useState } from 'react';
import { Header, LocalStorage, StorableDataKeys, HeaderContext } from '@weddingspot/ws-core-components';
import usePrevious from '../../hooks/usePrevious';

/**
 * Header variant for SRP
 */
export const HeaderSRP = () => {
    const { profileVersion } = React.useContext(HeaderContext);

    const [showShoppingCart, setShowShoppingCart] = useState(false);
    useEffect(() => {
        setShowShoppingCart(profileVersion === 'v3');
    }, [profileVersion]);
    // shoppingCartExperienceFinished becomes true after showShoppingCartExperience rendered
    // and can change from false to true only
    // so we using showingShoppingCartExperience state variable to avoid popUp closing on
    // shoppingCartExperienceFinished change
    const shoppingCartExperienceShowed = LocalStorage.getItem(StorableDataKeys.SRP_SHOPPING_CART_EXPERIENCE_SHOWED);
    const [showShoppingCartExperience, setShowShoppingCartExperience] = React.useState(!shoppingCartExperienceShowed);
    const prevShowShoppingCartExperience = usePrevious(showShoppingCartExperience);
    React.useEffect(() => {
        if (prevShowShoppingCartExperience === false) {
            setShowShoppingCartExperience(true);
        }
    }, [shoppingCartExperienceShowed]);

    return <Header isSticky={true} showShoppingCart={showShoppingCart} showShoppingCartExperience={showShoppingCartExperience} />;
};
